import { gsap } from "gsap";
import { Graphics, Sprite } from "pixi.js";

import { AbstractView } from "../../../../abstracts/modules/AbstractView";
import { AbstractWinScreen } from "../../../../abstracts/modules/screens/AbstractWinScreen";
import { generateScaledSprite } from "../../../../abstracts/utils/GraphicUtils";
import { playSound } from "../../../../abstracts/utils/SoundUtils";
import { displayConfig } from "../../../UCConfig";
import { UCSoundNames } from "../../../assetsLoader/UCAssetsNames";

export class UCSpinsWinScreen extends AbstractWinScreen {
    protected spinsWinSprite: Sprite;

    constructor(parentContainer: AbstractView) {
        super(`UCSpinsWinScreen`, parentContainer);
    }

    protected init(): void {
        super.init();

        this.bgGraphics = new Graphics();
        this.bgGraphics.beginFill(0x000000);
        this.bgGraphics.drawRect(
            0,
            0,
            displayConfig.backgroundWidth,
            displayConfig.backgroundHeight
        );
        this.bgGraphics.endFill();
        this.bgGraphics.alpha = 0.7;
        this.bgGraphics.name = `hawkBgGraphics`;
        this.bgGraphics.pivot.set(this.bgGraphics.width / 2, this.bgGraphics.height / 2);
        this.addChild(this.bgGraphics);
    }

    public override getGsapAnimation(spinsNo: number = 1): gsap.core.Tween | gsap.core.Timeline {
        const tl = gsap.timeline({});

        this.spinsWinSprite = generateScaledSprite(`+${spinsNo}s`);
        this.spinsWinSprite.name = `spinsWin`;
        this.spinsWinSprite.scale.set(0.5);
        this.spinsWinSprite.anchor.set(0.5);
        this.spinsWinSprite.alpha = 0;
        this.addChild(this.spinsWinSprite);

        const duration = 1.3;
        const showBg = gsap.fromTo(
            this.bgGraphics,
            { alpha: 0 },
            {
                alpha: 0.6,
                duration: duration * 0.4,
            }
        );
        tl.add(showBg, 0);

        const showSpinsSpriteTween = gsap.fromTo(
            this.spinsWinSprite,
            { alpha: 0, pixi: { scale: 0.2 } },
            {
                alpha: 1,
                pixi: { scale: 0.5 },
                duration: duration * 0.5,
                ease: `back.out(1.7)`,
                onStart: () => {
                    this.parentContainer.addChild(this);
                    playSound({ name: UCSoundNames.EXTRA_SPINS_WON });
                },
            }
        );
        tl.add(showSpinsSpriteTween, 0);

        const hideSpinsWinSprite = gsap.fromTo(
            this.spinsWinSprite,
            { alpha: 1, pixi: { scale: 0.5 } },
            {
                alpha: 0,
                pixi: { scale: 0.7 },
                duration: 0.2 * duration,
                ease: `back.in(1.4)`,
                onComplete: () => {
                    this.removeChild(this.spinsWinSprite);
                    this.spinsWinSprite.destroy();
                    this.parentContainer.removeChild(this);
                },
            }
        );
        tl.add(hideSpinsWinSprite, 0.8 * duration);

        const hideBg = gsap.fromTo(
            this.bgGraphics,
            { alpha: 0.6 },
            {
                alpha: 0,
                duration: 0.2 * duration,
                ease: `back.in(1.4)`,
            }
        );
        tl.add(hideBg, `<`);

        return tl;
    }
}
